import chart from './components/chart'
import common from './components/common'
import url from './components/url'

const main = {
  initFromHash: () => {
    const hash = url.getUrlHash()

    if (url.getUrlHash()) {
      $('[data-visualization]').removeClass('-active')
      $('[data-visualization=chart]').addClass('-active')

      chart.initChart({ variable: hash, type: 'daily', id: 0 })

      setTimeout(() => {
        $(`#comparative-chart-${hash}`).trigger('click')

        $('[data-visualization-content]').addClass('_none')
        $(`[data-visualization-content=chart]`).removeClass('_none')
      })
    }
  },

  /**
   * Controla a exibição dos gráficos horários
   */
  controlHourlyChart: () => {
    $(document).on('click', '.act-open-hourly-chart', function () {
      const id = $(this).data('id')

      $(this).find('.fa').toggleClass('fa-chevron-up')

      $(`#wrapper-chart-${id}`).slideToggle('fast', () => chart.initChart({ id }))
    })
  },

  /**
   * Controla o tipo de visualização das informações
   * Lista de dias || gráfico de comparação diária
   */
  controlVisualization: () => {
    $(document).on('click', '.act-change-visualization', function () {
      const visualization = $(this).data('visualization')

      $('[data-visualization]').removeClass('-active')
      $(this).addClass('-active')

      $('[data-visualization-content]').addClass('_none')
      $(`[data-visualization-content=${visualization}]`).removeClass('_none')

      if (visualization == 'chart') chart.initChart({ type: 'daily', id: 0 })
    })
  },

  controlForecastStories: () => {
    $(document).on('click', '.act-control-forecast-stories', function () {
      const id = $(this).data('id')

      $('[data-carousel-name=forecast-stories]').owlCarousel('destroy')
      $('[data-carousel-name=forecast-stories]').owlCarousel({
        dots: false,
        lazyLoad: true,
        loop: false,
        touchDrag: true,
        items: 1,
        startPosition: id
      })
    })

    $('[data-navigator-index]').on('click', function () {
      const carousel = $(this).data('carousel')
      const index = $(this).data('navigator-index')

      $(`[data-carousel-name=${carousel}]`).trigger('to.owl.carousel', [index])
    })

    $('[data-navigator-next]').on('click', function () {
      const carousel = $(this).data('carousel')

      $(`[data-carousel-name=${carousel}]`).trigger('next.owl.carousel')
    })

    $('[data-navigator-prev]').on('click', function () {
      const carousel = $(this).data('carousel')

      $(`[data-carousel-name=${carousel}]`).trigger('prev.owl.carousel')
    })
  },

  fixFirefoxBug: () => {
    /* Correção de bug que acontecia na pagina de previsão 15-dias apenas no
    firefox */

    const browser = navigator.userAgent
    const currentUrl = window.location.href
    const oldUrl = localStorage.getItem('urlReferrer')

    if (browser.indexOf("Firefox") > -1) {
      if (oldUrl === null || oldUrl != currentUrl) {
        localStorage.setItem('urlReferrer', currentUrl)
      } else {
        localStorage.removeItem('urlReferrer')
        location.reload(true)
      }
    }
  },

}

main.initFromHash()
main.controlHourlyChart()
main.controlVisualization()
main.controlForecastStories()
main.fixFirefoxBug()
common.handleFavoriteButtonClick()
common.backToTopButton()
